<template>
 <div class="chat-expert-card">
  <!-- Header Section -->
  <div class="header">
   <div class="text-section">
    <div class="title">Chat with SEBI Experts</div>
    <div class="subtitle">Get Personalized Guidance from SEBI Experts to Navigate the Stock Market</div>
   </div>
   <el-button type="primary" class="explore-btn" @click="$router.push('/expert-list')">Explore</el-button>
  </div>

  <!-- Expert Info List -->
  <div class="expert-info" v-for="(expert, index) in experts" :key="index">
   <img @click="goToExpertStore(expert)" class="expert-photo" :src="expert.profileImage" alt="" />
   <div class="expert-details">
    <div class="expert-name" v-if="expert.fullName">{{ expert.fullName }}</div>
    <div class="sebi-id" v-if="expert.sebiNumber">SEBI No: {{ expert.sebiNumber }}</div>
   </div>
   <el-button type="success" class="chat-btn" @click="$router.push('/expert-list')">
    <i class="el-icon-chat-line-round"></i>
    Chat
   </el-button>
  </div>
 </div>
</template>
  
  <script>
import { required } from 'vuelidate/lib/validators';

export default {
 name: 'ChatExpertCommunity',
 props: {
  experts: {
   typea: Array,
   required: true,
  },
 },
 data() {
  return {
   //  experts: [
   //   {
   //    photo: 'https://randomuser.me/api/portraits/men/75.jpg',
   //    name: 'Ravi Verma',
   //    sebiId: 'INA000012345',
   //   },
   //   {
   //    photo: 'https://randomuser.me/api/portraits/women/65.jpg',
   //    name: 'Anita Desai',
   //    sebiId: 'INA000067891',
   //   },
   //   {
   //    photo: 'https://randomuser.me/api/portraits/men/45.jpg',
   //    name: 'Siddharth Sharma',
   //    sebiId: 'INA000098765',
   //   },
   //  ],
  };
 },

 methods: { 
  goToExpertStore(expert) {
  // console.log('expert object:', expert);
  // console.log('user_id:', expert.expertId);
  // console.log('full_name:', expert.fullName);

  this.$store.commit('commitExpertDetails', {});
  this.$router.push({
    path: '/expert-store',
    query: {
      user_id: expert.expertId,
      user: 'individual',
      name: expert.fullName,
    },
  });
}
}
};
</script>
  
  <style scoped>
.chat-expert-card {
 background-color: #ffffff;
 border-radius: 10px;
 box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
 overflow: hidden;
 width: 100%;
}

.header {
 background-color: #e8eef5;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 12px 16px;
}

.text-section {
 display: flex;
 flex-direction: column;
}

.title {
 color: #2488ff;
 font-weight: 700;
 font-size: 15px;
}

.subtitle {
 color: #818181;
 font-size: 10px;
 font-weight: 500;
 margin-top: 4px;
}

.explore-btn {
 font-size: 12px;
 padding: 6px 12px;
 background-color: #ffffff;
 border-color: #2488ff;
 color: #2488ff;
 margin-left: 10px;
 font-weight: 600;
}

.expert-info {
 display: flex;
 align-items: center;
 justify-content: space-between;
 padding: 12px 16px;
 border-top: 1px solid #f0f0f0;
}

.expert-photo {
 width: 40px;
 height: 40px;
 border-radius: 50%;
 object-fit: cover;
 cursor:pointer;
}

.expert-details {
 flex: 1;
 margin-left: 12px;
}

.expert-name {
 font-size: 14px;
 font-weight: 600;
 color: #333;
}

.sebi-id {
 font-size: 10px;
 font-weight: 500;
 color: #666;
 margin-top: 2px;
}

.chat-btn {
 font-size: 12px;
 padding: 6px 12px;
 background-color: #2488ff;
 color: #fff;
 border: none;
 margin-left: 10px;
 font-weight: 600;
}
</style>
  